import { render, staticRenderFns } from "./select-house-require-read.vue?vue&type=template&id=198dd446"
import script from "./select-house-require-read.vue?vue&type=script&lang=ts"
export * from "./select-house-require-read.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports